export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.woff2?afac89562a53014590692a199d237a09";